// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rd-with-pd-logo__rd-text[data-v-37385252]{fill-rule:evenodd;clip-rule:evenodd;fill:var(--font-color)}.rd-with-pd-logo__chevron[data-v-37385252]{fill-rule:evenodd;clip-rule:evenodd;fill:var(--brand-color)}.rd-with-pd-logo__text[data-v-37385252]{fill:var(--font-color)}", ""]);
// Exports
module.exports = exports;
